import { defineComponent as _defineComponent } from 'vue'
import BCXCollapsible from '@/components/molecules/BCXCollapsible.vue';
import ProfileQuickInfoSkeleton from '@/components/molecules/ProfileQuickInfoSkeleton.vue';
import Chevron from '@/components/svg-components/Chevron.vue';
import { HtmlTarget } from '@/models/HtmlTarget';
import { ProfileStoreKey } from '@/models/Profile';
import { User } from '@/models/User';
import useProfileState from '@/state/profile/profileState';
import useQuickInfo from '@/state/quickInfo';
import ContactHistory from '@/views/profile/components/ContactHistory.vue';
import ProfileSection from '@/views/profile/components/ProfileSection.vue';
import ProfileBasicView from '@/views/profile/components/views/ProfileBasicView.vue';
import ProfileCertificatesEducationsView from '@/views/profile/components/views/ProfileCertificatesEducationsView.vue';
import ProfileInvitedBy from '@/views/profile/components/views/ProfileInvitedBy.vue';
import ProfilePreferencesView from '@/views/profile/components/views/ProfilePreferencesView.vue';
import ProfileProjectsView from '@/views/profile/components/views/ProfileProjectsView.vue';
import ProfileReferencesView from '@/views/profile/components/views/ProfileReferencesView.vue';
import ProfileQuickInfoSkillsView from '@/views/profile/components/views/ProfileQuickInfoSkillsView.vue';
import {
  computed, onMounted, PropType, ref, watch
} from 'vue';
import { toRefs, useVModel } from '@vueuse/core';
import ProfileAboutusView from '@/views/profile/components/views/ProfileAboutusView.vue';
import ProfileMembersView from '@/views/profile/components/views/ProfileMembersView.vue';
import ProfilePublicProjectsView from '@/views/profile/components/views/ProfilePublicProjectsView.vue';
import useUser from '@/mixins/useUser';
import useResponsiveness from '@/mixins/useResponsiveness';
import UserBadgesLegend from './components/UserBadgesLegend.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileQuickInfo',
  props: {
  user: {
    type: Object as PropType<User>,
    default: () => null
  },
  showMore: {
    type: Boolean
  },
  target: {
    type: String as PropType<HtmlTarget>,
    default: '_self'
  },
  isOnePager: Boolean
},
  emits: ['show-profile'],
  setup(__props, { emit }) {

const props = __props;



const { isSmartphoneWidth } = useResponsiveness();

const isExpanding = ref(false);
const { user: propUser } = toRefs(props);
const {
  init, profile, user: stateUser, isSectionFilled
} = useProfileState(ProfileStoreKey.QUICK_INFO, propUser);
const showMoreVM = useVModel(props, 'showMore');

const { displayedSection } = useQuickInfo();
init();

const showProfile = computed(() => !!stateUser.value && !!profile.value);

watch(showProfile, (show) => {
  if (show) {
    emit('show-profile');
  }
});

const {
  isCustomer, isFreelancer
} = useUser(stateUser);

onMounted(() => {
  if (isSmartphoneWidth.value) showMoreVM.value = true; // It should be initially true on the smartphone.
});


return { __sfc: true,props, emit, isSmartphoneWidth, isExpanding, propUser, init, profile, stateUser, isSectionFilled, showMoreVM, displayedSection, showProfile, isCustomer, isFreelancer, BCXCollapsible, ProfileQuickInfoSkeleton, Chevron, ContactHistory, ProfileSection, ProfileBasicView, ProfileCertificatesEducationsView, ProfileInvitedBy, ProfilePreferencesView, ProfileProjectsView, ProfileReferencesView, ProfileQuickInfoSkillsView, ProfileAboutusView, ProfileMembersView, ProfilePublicProjectsView, UserBadgesLegend }
}

})